export default "__VITE_ASSET__CP9Lpkf9__"